import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { ScrollToHash } from './components/ScrollToHash';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="31bs09botatln">
      <ScrollToHash data-id="element-1" data-mp="31c9ygdv1bhw7" />
      <Routes data-id="element-2" data-mp="31cjn9y4cfj0b">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-4" data-mp="2wj8dbo48im46" />} data-id="element-3" data-mp="2wk06ksad07ra" />
        <Route path="/legal/:slug" element={<Legal data-id="element-6" data-mp="28sbend1g9lav" />} data-id="element-5" data-mp="28t4lee0esat0" />
        <Route path="*" element={<Legal data-id="element-8" data-mp="23w4drynwuzzs" />} data-id="element-7" data-mp="23vkwmk634fmt" />
      </Routes>
    </BrowserRouter>;
}